import Vue from 'vue'
import ToastComponent from '@/components/Toast.vue'

// 创建 Toast 实例
const ToastConstructor = Vue.extend(ToastComponent)

let toastInstance = null

function getInstance() {
  if (!toastInstance) {
    toastInstance = new ToastConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(toastInstance.$el)
  }
  return toastInstance
}

const toast = {
  show(message, type = 'info', duration = 3000) {
    const instance = getInstance()
    instance.show(message, type, duration)
  },
  success(message, duration = 3000) {
    this.show(message, 'success', duration)
  },
  error(message, duration = 3000) {
    this.show(message, 'error', duration)
  },
  warning(message, duration = 3000) {
    this.show(message, 'warning', duration)
  },
  info(message, duration = 3000) {
    this.show(message, 'info', duration)
  }
}

export default toast
